import React from 'react'
import { VStack, HStack, Text, Wrap, Alert, AlertIcon, Spinner } from '@chakra-ui/react'
import { TagRecommendation } from '@/types'
import { TagSuggestionCard } from './TagSuggestionCard'

interface TagSuggestionsListProps {
  suggestions: TagRecommendation[]
  isLoading: boolean
  error: string | null
  selectionCount: number
  onToggleTag: (tagName: string) => void
  isTagSelected: (tagName: string) => boolean
  loadingText?: string
  emptyMessage?: string
}

export function TagSuggestionsList({
  suggestions,
  isLoading,
  error,
  selectionCount,
  onToggleTag,
  isTagSelected,
  loadingText = 'Loading suggestions...',
  emptyMessage = 'No suggestions found.',
}: TagSuggestionsListProps) {
  if (isLoading) {
    return (
      <HStack justify="center" py={8}>
        <Spinner size="md" />
        <Text>{loadingText}</Text>
      </HStack>
    )
  }

  if (error) {
    return (
      <Alert status="error">
        <AlertIcon />
        <Text>{error}</Text>
      </Alert>
    )
  }

  if (suggestions.length === 0) {
    return (
      <Alert status="warning">
        <AlertIcon />
        <Text>{emptyMessage}</Text>
      </Alert>
    )
  }

  return (
    <VStack spacing={3} align="stretch">
      <HStack justify="space-between">
        <Text fontWeight="semibold">Suggested Tags ({suggestions.length})</Text>
        <Text fontSize="sm" color="gray.600">
          {selectionCount} selected
        </Text>
      </HStack>
      <Wrap spacing={3}>
        {suggestions.map((recommendation) => (
          <TagSuggestionCard
            key={recommendation.tag_name}
            recommendation={recommendation}
            isSelected={isTagSelected(recommendation.tag_name)}
            onToggle={onToggleTag}
          />
        ))}
      </Wrap>
    </VStack>
  )
}
